export enum InterventionTypes {
  None = 'None',
  PlaceItemOnScale = 'PlaceItemOnScale',
  PlaceItemOnScaleInformativeMessage = 'PlaceItemOnScaleInformativeMessage',
  UnattendedWeight = 'UnattendedWeight',
  UnattendedWeightTimeout = 'UnattendedWeightTimeout',
  WeightMismatch = 'WeightMismatch',
  ProhibitedItem = 'ProhibitedItem',
  PriceVerification = 'PriceVerification',
  PriceEntry = 'PriceEntry',
  PaymentAssistantNeeded = 'PaymentAssistantNeeded',
  EftMissingDataFields = 'EftMissingDataFields',
  EftFailed = 'EftFailed',
  OnlineItem = 'OnlineItem',
  ElectronicItem = 'ElectronicItem',
  OverBag = 'OverBag',
  ManagerApproval = 'ManagerApproval',
  ManagerApprovalCancelRequireAttendant = 'ManagerApprovalCancelRequireAttendant',
  UserCallAssistant = 'UserCallAssistant',
  GeneralIntervention = 'GeneralIntervention',
  ProhibitedAction = 'ProhibitedAction',
  SellingRestriction = 'SellingRestriction',
  SigntureRequired = 'SigntureRequired',
  RestrictedByRule = 'RestrictedByRule',
  ProduceScaleError = 'ProduceScaleError',
  ProduceScaleHwError = 'ProduceScaleHwError',
  HwIntervention = 'HwIntervention',
  UnusedCoupons = 'UnusedCoupons',
  CustomerNotFound = 'CustomerNotFound',
  RecallOrderRestrictedByRule = 'RecallOrderRestrictedByRule',
  RecallOrderOnlineItem = 'RecallOrderOnlineItem',
  RecallOrderProductNotFound = 'RecallOrderProductNotFound',
  RecallOrderPriceVerifyRequired = 'RecallOrderPriceVerifyRequired',
  RecallOrderItemLockedForSale = 'RecallOrderItemLockedForSale',
  RecallOrderNoPriceExistPerUnitOfMeasure = 'RecallOrderNoPriceExistPerUnitOfMeasure',
  RecallOrderFailedToAddItem = 'RecallOrderFailedToAddItem',
  RecallOrderQuantityEntryRequired = 'RecallOrderQuantityEntryRequired',
  RecallOrderLinkedItem = 'RecallOrderLinkedItem',
  RecallOrderPriceEntryRequired = 'RecallOrderPriceEntryRequired',
}
